import { CheckoutLockedApoloServiceForm } from "./CheckoutLockedApoloServiceForm";

const Strategies = {
  CheckoutLockedApoloServiceForm,
};

export default Strategies;
